import { getStore } from '../store/store';
/**
 * Returns the suggestion at the index provided (or null if no suggestion
 * exists at that index).
 */
export default function getSuggestionAtIndex(index) {
    var suggestionsSet = getStore().currentSuggestions;
    // Return null if there are no suggestions.
    if (!suggestionsSet || !suggestionsSet.IsComplete) {
        return null;
    }
    // If there is no suggestion at the given index, return null.
    var suggestion = suggestionsSet.Suggestions[index];
    if (!suggestion) {
        return null;
    }
    return suggestion;
}
//# sourceMappingURL=getSuggestionAtIndex.js.map